'use client';

import { useEffect, useState } from 'react';

/**
 * 데스크톱 웹 여부 (`window.innerWidth > breakpoint`, 기본 600). resize 구독.
 *
 * SSR/하이드레이션 가드: 초기 `false`, mount 후 1회 측정. 모바일 웹/인앱 웹뷰(≤600)에선 항상
 * `false` 라, "desktop=새 탭 / 모바일·웹뷰=바텀시트" 분기에서 웹뷰가 새 탭을 타지 않는다.
 *
 * join(AccountFunnel) 약관 "자세히" 의 인라인 desktop 분기를 공용 추출 — 시딩 약관 desktop 분기와 공유.
 */
export const useIsDesktop = (breakpoint = 600): boolean => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const check = () =>
      setIsDesktop(typeof window !== 'undefined' && window.innerWidth > breakpoint);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [breakpoint]);

  return isDesktop;
};
